/**
 * Check if a position is inside container bounds
 */
export const isInsideContainer = (x: number, y: number, width: number, height: number): boolean => {
	return x >= 0 && x <= width && y >= 0 && y <= height;
};
